module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Medium.6e9c7e3.woff2";